import AsyncStorageLib from '@react-native-async-storage/async-storage';

const isWeb = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export async function getItem(key: string) {
  if (isWeb) return Promise.resolve(window.localStorage.getItem(key));
  return AsyncStorageLib.getItem(key);
}

export async function setItem(key: string, value: string) {
  if (isWeb) { window.localStorage.setItem(key, value); return Promise.resolve(); }
  return AsyncStorageLib.setItem(key, value);
}

export async function removeItem(key: string) {
  if (isWeb) { window.localStorage.removeItem(key); return Promise.resolve(); }
  return AsyncStorageLib.removeItem(key);
}
